// Geburtstagslogik für den Filter "Bevorstehende Geburtstage".
//
// Fallstricke, die hier bewusst abgedeckt sind:
//  - Jahreswechsel: am 30.12. ist ein Geburtstag am 02.01. in 3 Tagen, nicht in 362.
//  - Schaltjahr: der 29.02. wird in Nicht-Schaltjahren auf den 01.03. gelegt.
//  - Zeitzonen: alles in UTC, damit ein Geburtstag nicht um einen Tag springt.

const MS_PER_DAY = 86_400_000;

function utcMidnight(d: Date): number {
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

function isLeapYear(year: number): boolean {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

/**
 * Der nächste Jahrestag des Geburtstags ab `from` (einschließlich: heute = 0 Tage).
 */
export function nextBirthdayOccurrence(birthday: Date, from: Date = new Date()): Date {
  const month = birthday.getUTCMonth();
  const day = birthday.getUTCDate();
  const todayMs = utcMidnight(from);

  for (const year of [from.getUTCFullYear(), from.getUTCFullYear() + 1]) {
    // 29.02. in einem Nicht-Schaltjahr → am 01.03. feiern.
    const isLeapDay = month === 1 && day === 29;
    const effMonth = isLeapDay && !isLeapYear(year) ? 2 : month;
    const effDay = isLeapDay && !isLeapYear(year) ? 1 : day;

    const candidate = Date.UTC(year, effMonth, effDay);
    if (candidate >= todayMs) return new Date(candidate);
  }

  // Nicht erreichbar, aber der Typ verlangt eine Rückgabe.
  return new Date(Date.UTC(from.getUTCFullYear() + 1, month, day));
}

/** Tage bis zum nächsten Geburtstag. 0 = heute. */
export function daysUntilBirthday(birthday: Date, from: Date = new Date()): number {
  const next = nextBirthdayOccurrence(birthday, from);
  return Math.round((next.getTime() - utcMidnight(from)) / MS_PER_DAY);
}

/** Alter, das die Person am nächsten Geburtstag erreicht. */
export function turningAge(birthday: Date, from: Date = new Date()): number {
  return nextBirthdayOccurrence(birthday, from).getUTCFullYear() - birthday.getUTCFullYear();
}
